import React from "react"

export const defaultState = {
  roles: [],
  regions: [],
  regionsAsOptions: [],
  retailStores: [],
  retailStoresAsOptions: [],
  myProducts: [], // will be redundant b/c of MyEntityListing, but save it anyway
  myAssets: [], // will be redundant b/c of MyEntityListing, but save it anyway
  myBrands: [],
  myBrandsAsOptions: [],
  myProductsAsOptions: [],
  myAssetsAsOptions: [],
  myUsers: [],
  myUsersAsOptions: [],
  userGroups: [],
  myUserGroups: [],
  universalUserGroups: [],
  // Whether the user-group fetch has finished, regardless of what it returned.
  // Consumers need this to tell "still loading" from "loaded, nothing to show" —
  // an empty group list is not evidence that loading is still in flight (#329).
  userGroupsLoaded: false,
  tagsAsOptions: [],
  categoriesAsOptions: [],
  entityItemsNumber: {},
  myBookmarksID: {},
  myBookmarks: [],
  myBookmarksItems: {},
  myNotifications: [],
  onSiteMarketing: [],
  regionsAsOptionsCA: [],
  regionsAsOptionsUS: [],
  regionsAsOptions: [],
  productTagsAsOptions: [],
  productCategoriesAsOptions: [],
  storeCompaniesAsOptions: [],
  storeRegionsAsOptions: [],
  storeCitiesAsOptions: [],
  currentUserCompaniesAsOp: [],
  messages: null,
  // Loading states for progressive rendering.
  isLoading: true,
  loadingStates: {
    userGroups: true,
    assets: true,
    products: true,
    notifications: true,
    bookmarks: true,
    regions: true,
    stores: true,
    tags: true,
    categories: true,
    marketing: true,
    messages: true,
  },
}

const DataContext = React.createContext(defaultState)
export default DataContext
